import { useMutation } from "@apollo/client";
import { TrashIcon } from "@heroicons/react/24/outline";

import { Button, IconButton, Modal } from "../../../../../../../components/ui";
import { DELETE_EXHIBITION_WORK } from "../../../../../../../graphql/mutation/ExhibitionWork";
import useUser from "../../../../../../../hooks/useUser";

const Actions = ({ id: exhibitionWorkId }) => {
  const { hasPermission } = useUser();
  const [deleteExhibitionWork, { loading, error, reset }] = useMutation(
    DELETE_EXHIBITION_WORK(),
    { refetchQueries: ["FetchExhibitionWorks"] },
  );

  const modalProps = {
    title: "Delete Exhibition Work",
    description: error ? "" : "Are you sure?",
    scale: "sm",
    closeOnBackdrop: false,
    disabled: !hasPermission("DELETE_EXHIBITION_WORK"),
    body: ({ closeModal }) => {
      const handleDelete = async () => {
        const response = await deleteExhibitionWork({
          variables: { input: { id: exhibitionWorkId } },
          update: (cache, { data }) => {
            if (data?.deleteExhibitionWork?.success) {
              cache.evict({
                id: cache.identify({
                  __typename: "ExhibitionWork",
                  id: exhibitionWorkId,
                }),
              });
            }
          },
        });

        if (response?.data?.deleteExhibitionWork?.success) {
          closeModal();
        }
      };

      if (error) {
        return (
          <>
            <div className="mt-3 inline-flex items-center justify-start rounded-md border border-transparent px-4 py-2 font-bold font-medium text-red-800 sm:text-sm">
              {error?.message ||
                error?.graphQLErrors?.map?.(({ message }) => `${message} `) ||
                "An error occurred"}
            </div>
            <div className="mt-4 flex justify-end">
              <Button
                className="mr-3"
                label="Close"
                onClick={() => {
                  reset();
                  closeModal();
                }}
              />
            </div>
          </>
        );
      }

      return (
        <div className="mt-4 flex">
          <Button
            className="mr-3"
            label={"Cancel"}
            action={"default"}
            onClick={() => {
              closeModal();
            }}
          />
          <Button
            label={loading ? "Deleting" : "Delete"}
            disabled={loading}
            onClick={handleDelete}
          />
        </div>
      );
    },
  };

  if (!exhibitionWorkId) {
    return null;
  }

  return (
    <div className="user-list-actions flex text-right text-sm font-medium">
      <div className="grid">
        <Modal {...modalProps}>
          {hasPermission("DELETE_EXHIBITION_WORK") && (
            <IconButton variant="clean" title="Delete Exhibition Work">
              <TrashIcon className={`h-4 w-4 cursor-pointer text-gray-400`} />
            </IconButton>
          )}
        </Modal>
      </div>
    </div>
  );
};

export default Actions;
